/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/self-closing-comp */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Margin } from '../../../common/styles';
import Button from '../../../common/Button';
import CheckBox from '../../../common/CheckBox';
import ReviewOrderModal from '../../../common/Modal/reviewOrderModal';
import { Body, Title } from '../../../common/Typography/index';
import { checkIsMidnight, getSession, isLargedesktop, isMobile, isTablet, isVFEligibile, setSession } from '../../../common/Helpers';
import '../tos.css';
import { eventDispatcher } from '../../../common/Tagging/index';

const Wrapper = styled.div`
  .tosLinks {
    a {
      text-decoration: underline;
      color: #000000;
    }
  }
`;
export default class AgreementCheckBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      termsAndServiceModalVisible: false,
      enableAgreeContBtn: false,
      modelLoad: false,
    };
    this.modalChanged = this.modalChanged.bind(this);
  }

  componentDidMount() {
    const idvalue = this.props.tosTypes[this.props.index].agreementType;
    const modalTosLink = document.getElementById(idvalue);
    if (modalTosLink) {
      modalTosLink.addEventListener('click', (e) => this.serviceModal(e));
      modalTosLink.addEventListener('keydown', (e) => {
        if (e.keyCode === 32 || e.keyCode === 13) {
          this.serviceModal(e);
          e.preventDefault();
        }
      });
    }
  }

  handleCheckbox = (e, id, contentTitle) => {
    const { name, updateTOSCheckBoxState, tosCheckBoxState, completeOrderButtonClicked } = this.props;
    completeOrderButtonClicked(false);

    if (name === 'customerAgreement') {
      const custAcceptedTnC = getSession('custAcceptedTnC');
      if (custAcceptedTnC) {
        this.setState({ checked: e.target.checked });
        updateTOSCheckBoxState({ ...tosCheckBoxState, custAgree: e.target.checked });
        this.props.change(e, id, contentTitle);
      } else {
        this.setState({ termsAndServiceModalVisible: 'customerAgreement' });
        updateTOSCheckBoxState({ ...tosCheckBoxState, custAgree: false });
      }
    } else if (name === 'verizonHomeDeviceProtectITTKAgreement') {
      const custAcceptedVHDP = getSession('custAcceptedVHDP');
      if (custAcceptedVHDP) {
        this.setState({ checked: e.target.checked });
        updateTOSCheckBoxState({ ...tosCheckBoxState, custVHDP: e.target.checked });
        this.props.change(e, id, contentTitle);
      } else {
        this.setState({ termsAndServiceModalVisible: 'verizonHomeDeviceProtectITTKAgreement' });
        updateTOSCheckBoxState({ ...tosCheckBoxState, custVHDP: false });
      }
    } else if (name === 'eppTCAgreement') {
      this.setState({ checked: e.target.checked });
      updateTOSCheckBoxState({ ...tosCheckBoxState, eppTCAgreement: e.target.checked });
      this.props.change(e, id, contentTitle);
    } else {
      this.setState({ checked: e.target.checked });
      updateTOSCheckBoxState({ ...tosCheckBoxState, terms: e.target.checked });
      this.props.change(e, id, contentTitle);
    }
  };

  modalChanged = (state) => {
    const { name, tosCheckBoxState, updateTOSCheckBoxState } = this.props;

    if (!state) {
      this.readCompAgreement();
      this.setState({
        termsAndServiceModalVisible: false,
      });
    } else if (name === 'customerAgreement') {
      const obj = { name: 'T&S modal opened', selector: '#agreement_model', data: { page: { throttle: 'nsa version|vhi|TS' } } };
      eventDispatcher('openView', obj);
      updateTOSCheckBoxState({ ...tosCheckBoxState, custAgree: false });
      this.setState({ checked: false, enableAgreeContBtn: false });
    } else if (name === 'verizonHomeDeviceProtectITTKAgreement') {
      if (isMobile() || isLargedesktop()) {
        updateTOSCheckBoxState({ ...tosCheckBoxState, custVHDP: false });
        this.setState({ checked: false, enableAgreeContBtn: true });
      } else {
        updateTOSCheckBoxState({ ...tosCheckBoxState, custVHDP: false });
        this.setState({ checked: false, enableAgreeContBtn: false });
      }
    }
  };

  closeModal = (e) => {
    e.preventDefault();
    this.setState({ termsAndServiceModalVisible: false });
  };

  acceptAgreement = () => {
    const { updateTOSCheckBoxState, tosCheckBoxState, contentTitle, name } = this.props;
    if (!tosCheckBoxState.custAgree && name === 'customerAgreement') {
      updateTOSCheckBoxState({ ...tosCheckBoxState, custAgree: true });
      this.props.change({ keyCode: 32, target: { checked: true } }, 'tosAgree1', contentTitle);
      this.setState({ checked: true });
      setSession('custAcceptedTnC', true);
      this.setState({
        termsAndServiceModalVisible: false,
      });
    } else if (!tosCheckBoxState.custVHDP && name === 'verizonHomeDeviceProtectITTKAgreement') {
      updateTOSCheckBoxState({ ...tosCheckBoxState, custVHDP: true });
      this.props.change({ keyCode: 32, target: { checked: true } }, 'tosAgree1', contentTitle);
      this.setState({ checked: true });
      setSession('custAcceptedVHDP', true);
      this.setState({
        termsAndServiceModalVisible: false,
      });
    }
  };

  readCompAgreement = () => {
    const model = document?.getElementById('agreement_dialog');
    const scrollHeightMobile = model?.scrollHeight || 0;
    const scrollTopMobile = model?.scrollTop || 0;
    const offsetHeightMobile = model?.offsetHeight || 0;
    const scrollHeightDesktop = model?.firstElementChild?.scrollHeight || 0;
    const scrollTopDesktop = model?.firstElementChild?.scrollTop || 0;
    const offsetHeightDesktop = model?.firstElementChild?.offsetHeight || 0;

    if (scrollHeightDesktop !== offsetHeightDesktop) {
      if (offsetHeightDesktop + scrollTopDesktop + 1 >= scrollHeightDesktop) {
        this.setState({ enableAgreeContBtn: true });
      }
    }
    if (scrollHeightMobile !== offsetHeightMobile) {
      if (offsetHeightMobile + scrollTopMobile + 1 >= scrollHeightMobile) {
        this.setState({ enableAgreeContBtn: true });
      }
    }
  };

  serviceModal(e) {
    this.setState({ termsAndServiceModalVisible: e.target.id });
  }

  render() {
    const { name, content, id, agreementText, ariaLabel, contentTitle, tosCheckBoxState } = this.props;

    const { enableAgreeContBtn, termsAndServiceModalVisible, modelLoad } = this.state;
    if ((name === 'customerAgreement' || name === 'verizonHomeDeviceProtectITTKAgreement') && termsAndServiceModalVisible === contentTitle) {
      setTimeout(() => {
        const model = document?.getElementById('agreement_dialog');
        const scrollHeightMobile = model?.scrollHeight || 0;
        const offsetHeightMobile = model?.offsetHeight || 0;
        const scrollHeightDesktop = model?.firstElementChild?.scrollHeight || 0;
        const offsetHeightDesktop = model?.firstElementChild?.offsetHeight || 0;

        if (scrollHeightDesktop !== offsetHeightDesktop) {
          this.setState({ modelLoad: model?.firstElementChild });
        }
        if (scrollHeightMobile !== offsetHeightMobile) {
          this.setState({ modelLoad: model });
        }
      }, 2000);
    }
    if (modelLoad) {
      modelLoad.addEventListener('scroll', this.readCompAgreement);
    }
    let error = false;
    if (name === '5GTerms' && tosCheckBoxState?.terms === false) {
      error = true;
    }
    if (name === 'customerAgreement' && tosCheckBoxState?.custAgree === false) {
      error = true;
    }
    if (name === 'verizonHomeDeviceProtectITTKAgreement' && tosCheckBoxState?.custVHDP === false) {
      error = true;
    }
    if (name === 'eppTCAgreement' && tosCheckBoxState?.eppTCAgreement === false) {
      error = true;
    }
    if (name === 'WHWTerms' && tosCheckBoxState?.terms === false) {
      error = true;
    }

    const dataTrackLink =
      name === 'customerAgreement'
        ? '{"type": "link", "name": "Verizon Wireless Customer Agreement click", "data":{"page":{"throttle":"nsa version|vhi|TS" }}}'
        : '';
    const isEligible = isVFEligibile();
    const dataTrackCheckbox =
      name === 'customerAgreement'
        ? `{"type": "link", "name": "${
            isEligible ? 'customer agreement checked' : 'Customer Agreement'
          }", "data":{"page":{"throttle":"nsa version|vhi|TS" }}}`
        : name === '5GTerms'
          ? `{"type": "link", "name": 'Verizon home internet terms of service', "data":{"page":{"throttle":"nsa version|vhi|TS" }}}`
          : '';

    return (
      <Wrapper className={isMobile() ? 'marginTop23' : 'marginTop12'}>
        <div className="tosCheckBox noPadding">
          <CheckBox
            className="checkboxAlign"
            dataTrack={dataTrackCheckbox}
            id={id}
            name={`${name
              ?.replace('5GTerms', 'Verizon home internet terms of service')
              .replace('customerAgreement', 'customer Agreement')
              .replace('WHWTerms', 'whw - tte terms')} ${this.state.checked ? 'unchecked' : 'checked'}`}
            component="input"
            aria-checked={this.state.checked}
            onChange={(e) => this.handleCheckbox(e, id, contentTitle)}
            ariaLabel={ariaLabel && ariaLabel.replace(/<a\s+href='#'\s+tabindex=0>|<\/a>/g, '')}
            selected={this.state.checked}
            error={error}
            tabIndex="0"
          ></CheckBox>
          <div className={isTablet() ? 'checkboxLabel marginLeft5' : 'checkboxLabel'}>
            <Body primitive="p" size="large">
              <div className="tosLinks" data-track={dataTrackLink} dangerouslySetInnerHTML={{ __html: content }} />
            </Body>
          </div>
          {name === 'customerAgreement' && this.state.checked === false && !checkIsMidnight() && (
            <Margin top="25px">
              <Title size="XSmall" bold color="#000000">
                Please go through the customer agreement to proceed further.
              </Title>
            </Margin>
          )}
          <ReviewOrderModal
            custAcceptedTnC
            custAcceptedVHDP
            ariaLabel={
              contentTitle === 'customerAgreement'
                ? 'verizon wireless customer agreement overlay'
                : 'verizon home internet (wireless) terms of service overlay'
            }
            opened={this.state.termsAndServiceModalVisible === contentTitle}
            onOpenedChange={this.modalChanged}
            modalTitle=""
            name={name}
            acceptAgreement={(e) => this.acceptAgreement(e)}
            id="agreement_model"
            contentContainer="agreement_dialog"
            enableAgreeContBtn={enableAgreeContBtn}
            modalBody={
              <div style={{ marginTop: isMobile() ? '20px' : '' }}>
                <span dangerouslySetInnerHTML={{ __html: agreementText }} />{' '}
                {isMobile() && name !== 'customerAgreement' && name !== 'verizonHomeDeviceProtectITTKAgreement' && (
                  <Button onClick={this.closeModal} style={{ width: '100%' }}>
                    Continue
                  </Button>
                )}
              </div>
            }
          />
        </div>
      </Wrapper>
    );
  }
}

AgreementCheckBox.propTypes = {
  name: PropTypes.string,
  content: PropTypes.string,
  change: PropTypes.func,
  id: PropTypes.string,
  contentTitle: PropTypes.string,
  agreementText: PropTypes.string,
  ariaLabel: PropTypes.string,
  tosTypes: PropTypes.any,
  index: PropTypes.any,
  tosCheckBoxState: PropTypes.object,
  updateTOSCheckBoxState: PropTypes.func,
  completeOrderButtonClicked: PropTypes.func,
};
